import { ScenarioDto } from "../../components/Admins/Types/types";
import { axiosClient } from "../axiosClient";

export const createScenariosApi = async (dto: ScenarioDto) => {
    return await axiosClient.post<ScenarioDto>(`/scenarios`, dto);
};

export const updateScenarioApi = async(dto:ScenarioDto)=>{
    return await axiosClient.put<ScenarioDto>(`/scenarios/${dto.id}`, dto)
}

export const getScenariosApi = async () => {
    return await axiosClient.get<ScenarioDto[]>(`/scenarios`);
}

export const deleteScenarioApi = async (id: number) => {
    return await axiosClient.delete<boolean>(`/scenarios/${id}`)
}